export const ConfigurationsActionTypes = {
  API_RESPONSE_SUCCESS: '@@configuration/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@configuration/API_RESPONSE_ERROR',

  GET_CONFIGURATION: '@@configuration/GET_CONFIGURATION',
  UPDATE_CONFIGURATION: '@@configuration/UPDATE_CONFIGURATION',

  RESET: '@@configuration/RESET',
  RESET_BASIC: '@@configuration/RESET_BASIC'
}
